<template>
	<div class="check-bottom">
		<div class="check-content">
			<div class="title">
				<div class="text">{{ caseText }}</div>
				<img class="arrow_btm" :src="require('../../../../assets/appraise/arrowbtm.png')" @click="close" />
			</div>
			<div class="check-item">
				<van-checkbox-group v-model="result">
					<div class="horanal-div" v-for="(item, index) in caseData" :key="index">
						<div class="check-text">{{ item.text }}</div>
						<div class="check-div">
							<van-checkbox class="vancheck" checked-color="#07c160" :name="item.id" ref="checkboxes" icon-size="18px">
                <template #icon="props">
                  <img v-if="props.checked" style="width: 18px;" src="@/assets/appraise/active.jpg" alt="">
                  <img v-else-if="!props.checked" style="width: 18px;" src="@/assets/appraise/inactive.jpg" alt="">
                </template>
              </van-checkbox>
						</div>
					</div>
				</van-checkbox-group>
			</div>
			<div class="btm_btn">
				<cusBtn2 value="确定" @click="confirm"></cusBtn2>
			</div>
		</div>
	</div>
</template>
<script>
import { CheckboxGroup, Checkbox, } from "vant";
import cusBtn2 from "./cusBtn2";
export default {
    name: "bottomCheckbox",
    comments: {
        CheckboxGroup,
        Checkbox,
    },
	props: {
		caseData: {
			type: Array,
			default: () => {
				return [
					{ id: "traffic", text: "交通" },
					{ id: "police", text: "公安" },
					{ id: "tax", text: "税务" },
					{ id: "cult_tour", text: "文化和旅游" },
					{ id: "market_monitor", text: "市场监管" },
				];
			},
		},
		caseText: {
			type: String,
			default: () => {
				return "选择案件类别";
			},
		},
	},
	components: {
		cusBtn2,
	},
	data() {
		return {
			result: [],
		};
	},
	methods: {
        /** 确认 **/
        confirm() {
			console.log('选中结果：', this.result);
			let temArr = [];
			if( this.result && this.result.length > 0){
               for( let i = 0 ; i< this.caseData.length; i++){
                  for( let j = 0; j< this.result.length; j++){
                      if( this.result[j] === this.caseData[i].id){
                        temArr.push( this.caseData[i] );
					  }
				  }
			   }
			}
			// this.$emit('onConfirm', this.result);
			 this.$emit('onConfirm', temArr);
            this.close();
        },
        /** 关闭 **/
        close() {
            this.$emit('onClose');
        }
	},
};
</script>
<style lang="less" scoped>
.check-bottom {
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.3);
	position: fixed;
	top: 0;
	left: 0;
	.check-content {
		width: 100%;
		height: 343px;
		background: rgba(255, 255, 255, 1);
		position: absolute;
		bottom: 0;
		.check-item {
			width: 100%;
			padding: 0 16px 0 15px;
			.horanal-div {
				display: flex;
				justify-content: space-between;
				position: relative;
				height: 47px;
				.check-text {
					width: 100px;
					font-size: 16px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: rgba(51, 51, 51, 1);
					line-height: 47px;
				}
				.check-div {
					// width: 50px;
					display: flex;
					justify-content: space-between;
				}
			}
			.horanal-div::after {
				content: "";
				position: absolute;
				bottom: 0px;
				overflow: hidden;
				height: 1px;
				background-color: #eeeeee;
				width: 100%;
				transform: scaleY(0.6);
			}
		}
		.title {
			display: flex;
			justify-content: space-between;
			padding: 16px 18px 16px 15px;
			.text {
				min-width: 100px;
				font-size: 16px;
				font-family: PingFangSC-Semibold, PingFang SC;
				font-weight: 900;
				color: rgba(51, 51, 51, 1);
			}
			.arrow_btm {
				width: 14px;
				height: 14px;
			}
		}
		.btm_btn {
			height: 61px;
			width: 100%;
			display: flex;
			align-items: center;
			padding: 0 12px;
			position: absolute;
			bottom: 0;
		}
	}
}
</style>
